<template>
  <div class="design-width content work">
    <div class="work__grid">
      <div
        class="work__client"
        v-for="client in clients"
        :key="client.id || client.title"
        :style="{ backgroundColor: client.clientColor }"
      >
        <img
          v-if="client.clientLogo"
          :src="client.clientLogo.url"
          :alt="client.title"
          class="work__client__logo"
        />
        <a
          :href="'/work/' + proj.slug"
          class="work__client__project"
          v-for="proj in client.projects"
          :key="proj.slug"
          @click="openProject($event, proj.slug)"
        >
          <img v-if="proj.coverImage" :src="proj.coverImage.url" alt="" />
          <span class="title">{{ proj.title }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { ax, baseURL } from '../js/api';
import {pageMeta, pageTitle} from '../js/meta';
import { prepareCaseTransition } from '../js/case-transition';
import anime from 'animejs/lib/anime.es.js';

export default defineComponent({
  metaInfo: pageMeta({ title: pageTitle('Arbeiten') }),
  data: function () {
    return {
      clients: [],
      transitioning: false,
    };
  },
  created() {
    ax.get(`${baseURL}/api/categories/clients`)
      .then((response) => {
        // handle success
        this.clients = response.data.data;
      })
      .catch(function (error) {
        //console.error(error);
      })
      .finally(function () {
        // always executed
      });
  },
  methods: {
    openProject(event, slug) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.transitioning) return;
      this.transitioning = true;

      const rect = event.currentTarget.getBoundingClientRect();
      const clone = document.createElement('div');
      clone.className = 'work__transition';
      const mask = document.createElement('div');
      mask.className = 'work__transition__mask';
      Object.assign(mask.style, {
        left: `${rect.left}px`,
        top: `${rect.top}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
      });
      clone.appendChild(mask);
      document.body.appendChild(clone);

      anime({
        targets: mask,
        left: 0,
        top: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        duration: 500,
        easing: 'cubicBezier(0.52, 0.01, 0.16, 1)',
        complete: () => {
          prepareCaseTransition(slug, { type: 'grid', $clone: clone, $cloneMask: mask });
          this.$router.push({ name: 'work', params: { case: slug } })
            .then((failure) => {
              if (failure) {
                clone.remove();
                this.transitioning = false;
              }
            })
            .catch(() => {
              clone.remove();
              this.transitioning = false;
            });
        },
      });
    },
  },
});
</script>

<style lang="scss">
@import '../styles/_toolbox';

.work {
  &__transition {
    position: fixed;
    inset: 0;
    z-index: 100;
    pointer-events: none;

    &__mask {
      position: absolute;
      background: var(--c-bg);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
  &__client {
    aspect-ratio: 2/1;
    position: relative;
    display: flex;

    &:nth-child(6n + 1),
    &:nth-child(6n + 5) {
      grid-row: span 2;
      aspect-ratio: 1;
      flex-wrap: wrap;

      .work__client__project {
      }
    }
    &__logo {
      position: absolute;
      top: 25%;
      left: 25%;
      width: 50%;
      height: 50%;
      box-sizing: border-box;
      object-fit: contain;
    }

    &:hover .work__client__project {
      opacity: 1;
    }

    &__project {
      opacity: 0;
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      transition: opacity 0.2s ease-in-out;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .title {
        position: absolute;
        z-index: 2;
        width: 100%;
        color: #fff;
        text-align: center;
        font-size: 1.5em;
        line-height: 1.3;
      }
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(#000, 0.5);
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
    }
  }

  @include viewport(tablet) {
    &__client {
      grid-column: span 2;
    }
  }
}
</style>
